import { ts } from '@shared/lib/diagTs';

// Dev/demo-only diagnostics: the user copy-pastes these console lines for debugging.
// Gate: import.meta.env.MODE !== 'prod' (local='development', deployed dev='dev', demo='demo', prod='prod').
export const positionsDebug = import.meta.env.MODE !== 'prod';
export function plog(event: string, data?: unknown): void {
  if (!positionsDebug) return;
  // eslint-disable-next-line no-console
  console.log(`${ts()} [positions] ${event}`, data ?? '');
}
